import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import supabase from '../supabase';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function SurveyPublic() {
    const { slug } = useParams();
    const [survey, setSurvey] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [notFound, setNotFound] = useState(false);
    const [lang, setLang] = useState('fr');

    useEffect(() => {
        const fetchSurvey = async () => {
            const { data: s } = await supabase
                .from('surveys')
                .select('*')
                .eq('slug', slug)
                .eq('published', true)
                .single();

            if (!s) { setNotFound(true); setLoading(false); return; }
            setSurvey(s);

            const { data: q } = await supabase
                .from('survey_questions')
                .select('*')
                .eq('survey_id', s.id)
                .order('position');
            if (q) setQuestions(q);
            setLoading(false);
        };
        fetchSurvey();
    }, [slug]);

    const handleChange = (questionId, value) => {
        setAnswers({ ...answers, [questionId]: value });
    };

    const handleCheckbox = (questionId, option) => {
        const current = answers[questionId] || [];
        const updated = current.includes(option)
            ? current.filter(o => o !== option)
            : [...current, option];
        setAnswers({ ...answers, [questionId]: updated });
    };

    const handleSubmit = async () => {
        // Vérifie les requis
        for (const q of questions) {
            if (q.required) {
                const ans = answers[q.id];
                if (!ans || (Array.isArray(ans) && ans.length === 0) || ans === '') {
                    const label = lang === 'en' && q.label_en ? q.label_en : q.label;
                    alert(`${lang === 'en' ? 'The question' : 'La question'} "${label}" ${lang === 'en' ? 'is required.' : 'est requise.'}`);
                    return;
                }
            }
        }

        setSubmitting(true);
        const { error } = await supabase.from('survey_answers').insert([{
            survey_id: survey.id,
            answers,
            lang,
        }]);
        setSubmitting(false);
        if (!error) setSubmitted(true);
        else alert('Erreur lors de la soumission. Réessaie plus tard.');
    };

    const inputStyle = {
        width: '100%',
        padding: '10px 12px',
        border: '0.5px solid #e0e0e0',
        borderRadius: '6px',
        fontSize: '13px',
        fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
        color: '#333',
        boxSizing: 'border-box',
        outline: 'none',
        background: 'white',
    };

    const labelStyle = {
        display: 'block',
        fontSize: '10px',
        fontWeight: '500',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: '#888',
        marginBottom: '6px',
    };

    if (loading) return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>
            <Navbar variant="light" />
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa', fontSize: '13px' }}>Chargement...</div>
            <Footer />
        </div>
    );

    if (notFound) return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>
            <Navbar variant="light" />
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '8px' }}>
                <h2 style={{ fontWeight: '400', fontSize: '20px', color: '#111' }}>Survey introuvable</h2>
                <p style={{ fontSize: '13px', color: '#aaa' }}>Ce survey n'existe pas ou n'est plus disponible.</p>
            </div>
            <Footer />
        </div>
    );

    if (submitted) return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>
            <Navbar variant="light" />
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ textAlign: 'center', padding: '40px' }}>
                    <div style={{ fontSize: '32px', marginBottom: '16px' }}>🙏</div>
                    <h2 style={{ fontWeight: '400', fontSize: '20px', marginBottom: '8px', color: '#111' }}>{lang === 'en' ? 'Thank you for your response.' : 'Merci pour ta réponse.'}</h2>
                    <p style={{ fontSize: '13px', color: '#888' }}>{lang === 'en' ? 'Your answers have been recorded.' : 'Tes réponses ont bien été enregistrées.'}</p>
                </div>
            </div>
            <Footer />
        </div>
    );

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>
            <Navbar variant="light" />

            <div style={{ flex: 1, background: '#f7f7f7', padding: '48px 24px' }}>
                <div style={{ maxWidth: '560px', margin: '0 auto' }}>

                    {/* Header */}
                    <div style={{ marginBottom: '32px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <p style={{ fontSize: '10px', fontWeight: '500', letterSpacing: '0.1em', textTransform: 'uppercase', color: '#aaa', marginBottom: '8px' }}>Longden Collective</p>
                            {questions.some(q => q.label_en) && (
                                <div style={{ display: 'flex', border: '0.5px solid #e0e0e0', borderRadius: '20px', overflow: 'hidden' }}>
                                    {['fr', 'en'].map((lng) => (
                                        <button key={lng} onClick={() => setLang(lng)} style={{ padding: '4px 12px', fontSize: '11px', border: 'none', background: lang === lng ? '#111' : 'white', color: lang === lng ? 'white' : '#888', cursor: 'pointer', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>
                                            {lng.toUpperCase()}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                        <h1 style={{ fontWeight: '400', fontSize: '22px', color: '#111', margin: '0 0 8px' }}>
                            {lang === 'en' && survey.title_en ? survey.title_en : survey.title}
                        </h1>
                        {(survey.description || survey.description_en) && (
                            <p style={{ fontSize: '13px', color: '#888', margin: 0 }}>
                                {lang === 'en' && survey.description_en ? survey.description_en : survey.description}
                            </p>
                        )}
                    </div>

                    {/* Form */}
                    <div style={{ background: 'white', borderRadius: '12px', border: '0.5px solid #e0e0e0', padding: '28px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        {questions.map((q) => (
                            <div key={q.id}>
                                <label style={labelStyle}>
                                    {lang === 'en' && q.label_en ? q.label_en : q.label}
                                    {q.required && <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
                                </label>
                                {q.type === 'text' && (
                                    <input value={answers[q.id] || ''} onChange={e => handleChange(q.id, e.target.value)} style={inputStyle} />
                                )}

                                {q.type === 'textarea' && (
                                    <textarea value={answers[q.id] || ''} onChange={e => handleChange(q.id, e.target.value)} rows={3} style={{ ...inputStyle, resize: 'vertical' }} />
                                )}

                                {q.type === 'select' && (
                                    <select value={answers[q.id] || ''} onChange={e => handleChange(q.id, e.target.value)} style={inputStyle}>
                                        <option value="">—</option>
                                        {(lang === 'en' && q.options_en?.length > 0 ? q.options_en : q.options).map(opt => (
                                            <option key={opt} value={opt}>{opt}</option>
                                        ))}
                                    </select>
                                )}

                                {q.type === 'radio' && (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                        {(lang === 'en' && q.options_en?.length > 0 ? q.options_en : q.options).map((opt, i) => (
                                            <label key={opt} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#333', cursor: 'pointer' }}>
                                                <input type="radio" name={q.id} value={q.options[i]} checked={answers[q.id] === q.options[i]} onChange={() => handleChange(q.id, q.options[i])} />
                                                {opt}
                                            </label>
                                        ))}
                                    </div>
                                )}

                                {q.type === 'checkbox' && (
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                        {(lang === 'en' && q.options_en?.length > 0 ? q.options_en : q.options).map((opt, i) => {
                                            const value = q.options[i];
                                            const selected = (answers[q.id] || []).includes(value);
                                            return (
                                                <button key={opt} type="button" onClick={() => handleCheckbox(q.id, value)} style={{ padding: '5px 12px', borderRadius: '20px', border: selected ? '0.5px solid #111' : '0.5px solid #e0e0e0', background: selected ? '#111' : 'white', color: selected ? 'white' : '#555', fontSize: '12px', cursor: 'pointer', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif', transition: 'all 0.15s' }}>
                                                    {opt}
                                                </button>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        ))}

                        <button type="button" onClick={handleSubmit} disabled={submitting} style={{ width: '100%', padding: '11px', background: submitting ? '#ccc' : 'black', color: 'white', border: 'none', borderRadius: '6px', fontSize: '13px', cursor: submitting ? 'not-allowed' : 'pointer', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif', letterSpacing: '0.04em' }}>
                            {submitting ? (lang === 'en' ? 'Sending...' : 'Envoi...') : (lang === 'en' ? 'Submit' : 'Soumettre')}
                        </button>
                    </div>

                    <p style={{ textAlign: 'center', fontSize: '11px', color: '#ccc', marginTop: '20px' }}>© Winston.ie 2026</p>
                </div>
            </div>

            <Footer />
        </div >
    );
}